import { Product } from './product';
import { ProductChild } from './product-child';

export class CartItem {
    id = 0;
    user_id = 0;
    fingerprint = '';
    product_id = 0;
    child_id = 0;
    quantity = 0;
    price_unit: any = 0;

    product = new Product();
    child = new ProductChild();
}
